"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const material_1 = require("@mui/material");

const react_1 = __importStar(require("react"));

const react_select_1 = __importDefault(require("react-select"));

const PREFIX = 'SskyAutoComplete';
const classes = {
  input: `${PREFIX}-input`,
  valueContainer: `${PREFIX}-valueContainer`,
  noOptionsMessage: `${PREFIX}-noOptionsMessage`,
  singleValue: `${PREFIX}-singleValue`,
  placeholder: `${PREFIX}-placeholder`,
  menu: `${PREFIX}-menu`
};
const StyledSelect = (0, material_1.styled)(react_select_1.default)(({
  theme
}) => ({
  [`& .${classes.input}`]: {
    display: "flex",
    minWidth: 220
  },
  [`& .${classes.valueContainer}`]: {
    display: "flex",
    flex: 1,
    alignItems: "center"
  },
  [`& .${classes.noOptionsMessage}`]: {
    fontSize: 16,
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
  },
  [`& .${classes.singleValue}`]: {
    fontSize: 16
  },
  [`& .${classes.placeholder}`]: {
    position: "absolute",
    left: 2,
    fontSize: 16
  },
  [`& .${classes.menu}`]: {
    position: "absolute",
    zIndex: 9,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0
  }
}));

const inputComponent = _a => {
  var {
    inputRef
  } = _a,
      props = __rest(_a, ["inputRef"]);

  return react_1.default.createElement("div", Object.assign({
    ref: inputRef
  }, props));
};

const NoOptionsMessage = props => {
  return react_1.default.createElement(material_1.Typography, Object.assign({
    sx: {
      color: "textSecondary"
    },
    className: classes.noOptionsMessage
  }, props.innerProps), props.children);
};

const Control = props => {
  return react_1.default.createElement(material_1.TextField, {
    className: "uiTextField",
    variant: "standard",
    InputProps: {
      inputComponent,
      inputProps: Object.assign({
        className: classes.input,
        ref: props.innerRef,
        children: props.children
      }, props.innerProps)
    }
  });
};

const Option = props => {
  return react_1.default.createElement(material_1.MenuItem, Object.assign({
    buttonRef: props.innerRef,
    selected: props.isFocused,
    component: "div",
    style: {
      fontWeight: props.isSelected ? 500 : 400
    }
  }, props.innerProps), props.children);
};

const Placeholder = props => {
  return react_1.default.createElement(material_1.Typography, Object.assign({
    sx: {
      color: "textSecondary"
    },
    className: classes.placeholder
  }, props.innerProps), props.children);
};

const SingleValue = props => {
  return react_1.default.createElement(material_1.Typography, Object.assign({
    className: classes.singleValue
  }, props.innerProps), props.children);
};

const Menu = props => {
  return react_1.default.createElement(material_1.Paper, Object.assign({
    square: true,
    className: classes.menu
  }, props.innerProps), props.children);
};

const ValueContainer = props => {
  return react_1.default.createElement("div", {
    className: classes.valueContainer
  }, props.children);
};

const components = {
  Option,
  Control,
  Menu,
  NoOptionsMessage,
  Placeholder,
  SingleValue,
  ValueContainer
};
/**
 * @deprecated Use SskySelectAutocomplete instead
 */

class SskyAutoComplete extends react_1.PureComponent {
  render() {
    const selectStyles = {
      indicatorSeparator: provided => Object.assign(Object.assign({}, provided), {
        marginTop: 0,
        marginBottom: 0
      })
    };
    return react_1.default.createElement(StyledSelect, Object.assign({
      className: "AutoComplete",
      styles: selectStyles,
      components: components
    }, this.props));
  }

}

exports.default = SskyAutoComplete;